import React from "react";
import { Button } from "react-bootstrap";

const IconToggle = React.forwardRef(({ onClick, className, btnClassName, icon, disabled, size, type }: any, ref: any) => {
    const filteredClassName = className.replace('dropdown-toggle', '');

    return <Button variant="clear" className={`${btnClassName}`} onClick={onClick} ref={ref} disabled={disabled} type={type} size={size}>
        <i className={`bi ${icon} ${filteredClassName}`} />
    </Button>
});

export const ThreeDotsToggle = React.forwardRef((props: any, ref: any) => {
    return <IconToggle icon="bi-three-dots-vertical" ref={ref} {...props} />
});
export const ThreeDotsHorizontalToggle = React.forwardRef((props: any, ref: any) => {
    return <IconToggle icon="bi-three-dots" ref={ref} {...props} />
});
export const ThreeLinesToggle = React.forwardRef((props: any, ref: any) => {
    return <IconToggle icon="bi-list" ref={ref} {...props} />
});
export const AccountLinesToggle = React.forwardRef((props: any, ref: any) => {
    return <IconToggle icon="bi-person-lines-fill" ref={ref} {...props} />
});
